@if ((!applicationStateService.pageEditMode || (applicationStateService.pageEditMode && whiteboardDrawing.id > 0))) {
    <button (click)="onClick()"
            (keydown)="stopEvent($event)"
            (scroll)="stopEvent($event)"
            (swipeleft)="stopEvent($event)"
            (swiperight)="stopEvent($event)"
            (touchend)="preventDefault($event)"
            (touchstart)="preventDefault($event)"
            (wheel)="stopEvent($event)"
            [attr.id]="'whiteboard-rect-' +whiteboardDrawing.id"
            title="{{whiteboardDrawing.name}}">
    <span [ngStyle]="{background: whiteboardDrawing.color}" class="circle grow">
      <i [ngClass]="'fa ' + whiteboardDrawing.icon">
      </i>
    </span>
    </button>
}
